<template>
	<div class="login-register-from-space"  @click="riqifanshi=false">
		<div class="X5eogfqvbxD_ckZVQSll">{{ this.suportType }}<!--$t("Login._SuporteContaRegistro")--></div>
		<div v-if="$store.state.config.register_type == 'all'|| $store.state.config.register_type == 'name'">
			<div class="" style="margin-bottom: .2rem;">
				<antInput
					left-icon="a" :modelValue="formConter.user_name"
						@focus="onFocus"
						@blur="onBlur"
						@onInput="onInput"
						form-key='user_name'
						maxlength="16"
						:placeholder="$store.state.config.register_type == 'phone' ? $t('components._Containsira') : $t('components._Containsira')" :class="{
						'input-active':isFocus
					}"
				>
					<div slot="left" style="display: flex;align-items: center;">
						<svg-icon className="imageWrap"
							style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
							icon-class="input_icon_zh--svgSprite:all" />
						<span class="ZEcfoKF3Q_zq5EqaOdUy">
							<i v-if="!formConter.user_name">*</i>
						</span>
					</div>
				</antInput>
			</div>
			<div class="ant-form-explain" v-if="fonData.user_name.value">{{fonData.user_name.value}}</div>
		</div>
		
		<div v-if="$store.state.config.register_type == 'phone'">
			<div class="" style="margin-bottom: .2rem;" >
				<antInput
					left-icon="a" :modelValue="formConter.phone"
						@focus="onFocus"
						@blur="onBlur"
						@onInput="onInput"
						form-key='phone'
						type="Number"
						:placeholder="$t('Login._DigiteoNúmerodoCelular')" :class="{
						'input-active':isFocus
					}"
				>
					<div slot="left" @click.stop="riqifanshi=!riqifanshi" class="icontest" style="display: flex;align-items: center;color: var(--theme-text-color-lighten);">
						<img style="width: 0.36rem; height: 0.27rem;" :src="require('./../../assets/icons/images/'+country.name+'.png')" >
							<span style="font-size: .2rem;padding-left: .1rem;padding-right: .2rem;">{{country.code}}</span>
							<span unselectable="on"  class="ant-select-arrow" style="padding-right: .3rem;user-select: none;"
							><i  :style="{
								transform:riqifanshi?'rotate(-180deg)':'',
								transition:'.3s',
								display:'block'
							}" class="anticon anticon-down ant-select-arrow-icon"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 35.969 21.998" data-icon="down" fill="currentColor" aria-hidden="true" focusable="false" class=""><path id="comm_icon_fh" d="M2209.28,137.564l-17.743-15.773a2,2,0,0,1-.271-3.058,2.037,2.037,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,1,1-2.817,2.817Z" transform="translate(-102.181 2212.68) rotate(-90)"></path></svg></i></span>
							<span class="ZEcfoKF3Q_zq5EqaOdUy">
								<i v-if="!formConter.phone">*</i>
							</span>
					</div>
				</antInput>
				<div class="ant-select-dropdow"   @click.stop="riqifanshi=false" v-if="riqifanshi" style="width: auto;" >
					<div class="Conter_arrConte" style="width: auto;" >
						<div class="icontest" style="display: flex;align-items: center;color: var(--theme-text-color-lighten);width: auto;">
							<img style="width: 0.36rem; height: 0.27rem;" :src="require('./../../assets/icons/images/'+country.name+'.png')" >
							<span style="padding-left: .1rem;padding-right: .4rem;">{{country.full}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="ant-form-explain" v-if="fonData.phone.value">{{fonData.phone.value}}</div>
		</div>
		<div class="" style="margin-bottom: .2rem;">
			<antInput
				left-icon="a" :modelValue="formConter.password"
					@focus="onFocus"
					@blur="onBlur"
					@onInput="onInput"
					maxlength="16"
					form-key='password'
					:type="fonData.password.type"
					:placeholder="$store.state.config.register_type == 'name'?$t('withdraw._InserirSenha'):$t('Login._Senha')" :class="{
				 	'input-active':isFocus
				 }"
			>
				<div slot="left" style="display: flex;align-items: center;">
					<svg-icon className="imageWrap"
						style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
						icon-class="input_icon_mm--svgSprite:all" />
					<span class="ZEcfoKF3Q_zq5EqaOdUy">
						<i v-if="!formConter.password">*</i>
					</span>
				</div>
				<!-- fonData.password.type -->
				<div slot="right-icon" @click="showHide('password')">
					<svg-icon className="right-icon"
						style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
						:icon-class="fonData.password.type=='text'?'comm_icon_show--svgSprite:all':'comm_icon_hide--svgSprite:all'" />
				</div>
			</antInput>
		</div>
		<div class="ant-form-explain" v-if="fonData.password.value">{{fonData.password.value}}</div>
		
		<div class="ant-space-item" style="margin-bottom: 0px;">
			<div class="ptEr7ybENfgNXBPMnsRb">
				<div class="rBX8yUXrZ3DzhJ4ZvZUD">
					<span>{{ $t('components._Strength') }}</span>
					<span v-for="index in 4" :key="index" :style="{
						    backgroundColor:mimaQiangdu==4?'var(--theme-secondary-color-success) !important':''
					}" :class="{
						QZ0QekXF9duW7ClyMSdQ:index<=mimaQiangdu && formConter.password,
						
					}" class="VYe1C86O9HyF7KaCqIUg "></span>
				</div>
			</div>
		</div>
		
		<div class="" style="margin-bottom: .2rem;" v-if="fonData.password.type!='text'" >
			<antInput
				left-icon="a" :modelValue="formConter.password_confirm"
					@focus="onFocus"
					@blur="onBlur"
					@onInput="onInput"
					maxlength="16"
					form-key='password_confirm'
					:type="fonData.password_confirm.type"
					:placeholder="$store.state.config.register_type == 'name'?$t('components._novamentefavor'):$t('Login._Confirme')" :class="{
				 	'input-active':isFocus
				 }"
			>
				<div slot="left" style="display: flex;align-items: center;">
					<svg-icon className="imageWrap"
						style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
						icon-class="input_icon_mm--svgSprite:all" />
					<span class="ZEcfoKF3Q_zq5EqaOdUy">
						<i v-if="!formConter.password_confirm">*</i>
					</span>
				</div>
				<div slot="right-icon" @click="showHide('password_confirm')">
					<svg-icon className="right-icon"
						style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
						:icon-class="fonData.password_confirm.type=='text'?'comm_icon_show--svgSprite:all':'comm_icon_hide--svgSprite:all'" />
				</div>
			</antInput>
		</div>
		<div class="ant-form-explain" v-if="fonData.password_confirm.value && fonData.password.type!='text'">{{fonData.password_confirm.value}}</div>
		<div v-if="$store.state.config.register_type == 'all'">
			<div class="" style="margin-bottom: .2rem;" >
				<antInput
					left-icon="a" :modelValue="formConter.phone"
						@focus="onFocus"
						@blur="onBlur"
						@onInput="onInput"
						form-key='phone'
						type="Number"
						:placeholder="$t('Login._DigiteoNúmerodoCelular')" :class="{
						'input-active':isFocus
					}"
				>
					<div slot="left" @click.stop="riqifanshi=!riqifanshi" class="icontest" style="display: flex;align-items: center;color: var(--theme-text-color-lighten);">
						<img style="width: 0.36rem; height: 0.27rem;" :src="require('./../../assets/icons/images/'+country.name+'.png')" >
							<span style="font-size: .2rem;padding-left: .1rem;padding-right: .2rem;">{{country.code}}</span>
							<span unselectable="on"  class="ant-select-arrow" style="padding-right: .3rem;user-select: none;"
							><i  :style="{
								transform:riqifanshi?'rotate(-180deg)':'',
								transition:'.3s',
								display:'block'
							}" class="anticon anticon-down ant-select-arrow-icon"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 35.969 21.998" data-icon="down" fill="currentColor" aria-hidden="true" focusable="false" class=""><path id="comm_icon_fh" d="M2209.28,137.564l-17.743-15.773a2,2,0,0,1-.271-3.058,2.037,2.037,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,1,1-2.817,2.817Z" transform="translate(-102.181 2212.68) rotate(-90)"></path></svg></i></span>
							<span class="ZEcfoKF3Q_zq5EqaOdUy">
								<i v-if="!formConter.phone">*</i>
							</span>
					</div>
				</antInput>
				
				<div class="ant-select-dropdow"   @click.stop="riqifanshi=false" v-if="riqifanshi" style="width: auto;" >
					<div class="Conter_arrConte" style="width: auto;" >
						<div class="icontest" style="display: flex;align-items: center;color: var(--theme-text-color-lighten);width: auto;">
							<img style="width: 0.36rem; height: 0.27rem;" :src="require('./../../assets/icons/images/'+country.name+'.png')" >
							<span style="padding-left: .1rem;padding-right: .4rem;">{{country.full}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="ant-form-explain" v-if="fonData.phone.value">{{fonData.phone.value}}</div>
		</div>
		<div v-if="$store.state.config.register_cpf">
			<div class="" style="margin-bottom: .2rem;">
				<antInput
					left-icon="a" :modelValue="formConter.cpf"
						@focus="onFocus"
						@blur="onBlur"
						@onInput="onInput"
						form-key='cpf'
						maxlength="14"
						:placeholder="$t('components._IntroduzadoCPF')"
						:class="{'input-active':isFocus}"
				>
					<div slot="left" style="display: flex;align-items: center;">
						<svg-icon className="imageWrap"
							style="width: .26rem;height: .26rem;color: var(--theme-text-color-lighten);"
							icon-class="input_icon_cpf--svgSprite:all" />
						<span class="ZEcfoKF3Q_zq5EqaOdUy">
							<i v-if="!formConter.cpf">*</i>
						</span>
					</div>
				</antInput>
			</div>
			<div class="ant-form-explain" v-if="fonData.cpf.value">{{fonData.cpf.value}}</div>
		</div>
		<div v-if="$store.state.config.ui_version == '3.4'">
			<div class="" style="margin-bottom: .2rem;">
				<antInput
					left-icon="a" :modelValue="formConter.invite_code"
						@focus="onFocus"
						@blur="onBlur"
						@onInput="onInput"
						form-key='invite_code'
						maxlength="9"
						placeholder="Código de Convite"
						:class="{'input-active':isFocus}"
				>
					<div slot="left" style="display: flex;align-items: center;">
						<svg width="1em" height="1em" viewBox="0 0 13 13" fill="currentColor" style="color: var(--theme-text-color-lighten);">
							<path data-v-58efb1ef="" d="M12.7139 7.5779C12.7242 7.62557 12.7291 7.67378 12.7291 7.72253V11.9167C12.7291 12.0589 12.7011 12.1998 12.6466 12.3312C12.5922 12.4627 12.5124 12.5821 12.4118 12.6827C12.3112 12.7833 12.1918 12.8631 12.0603 12.9175C11.9289 12.972 11.788 13 11.6458 13H1.35409C1.21182 13 1.07095 12.972 0.939512 12.9175C0.808076 12.8631 0.68865 12.7833 0.588053 12.6827C0.487456 12.5821 0.407658 12.4627 0.353216 12.3312C0.298773 12.1998 0.270752 12.0589 0.270752 11.9167V7.72415C0.270752 7.39374 0.503127 7.12561 0.79021 7.12561C0.83246 7.12561 0.875252 7.13157 0.915877 7.14349L1.38767 7.25236L6.49992 8.66665L11.6154 7.25128L12.084 7.14294C12.3629 7.06224 12.6446 7.25669 12.7139 7.5779ZM8.81175 1.62499C8.71667 1.78967 8.66661 1.97648 8.66661 2.16665C8.66661 2.35681 8.71667 2.54362 8.81175 2.70831C8.90682 2.87299 9.04358 3.00975 9.20826 3.10484C9.37295 3.19992 9.55976 3.24998 9.74992 3.24999H10.0208V3.52082C10.0207 3.70865 10.0695 3.89327 10.1623 4.05656C10.2551 4.21986 10.3888 4.35621 10.5502 4.45225C10.7116 4.54828 10.8952 4.6007 11.083 4.60435C11.2708 4.608 11.4563 4.56276 11.6214 4.47307L11.6051 6.26924L6.49992 7.6819L1.39417 6.26924L1.36384 2.71753C1.36138 2.4303 1.4731 2.15385 1.67442 1.94898C1.87574 1.7441 2.15019 1.62756 2.43742 1.62499H8.81175ZM4.27259 3.39894H3.64642C3.34634 3.39894 3.10259 3.65461 3.10259 3.96986C3.10259 4.26453 3.31492 4.50611 3.58738 4.53753L3.64696 4.54078H4.2715C4.57213 4.54078 4.81588 4.28511 4.81588 3.96986C4.81588 3.65461 4.57213 3.39894 4.2715 3.39894H4.27259ZM8.42717 3.39894H5.98046C5.65275 3.39894 5.38734 3.65461 5.38734 3.96986C5.38734 4.26453 5.61863 4.50611 5.916 4.53753L5.981 4.54078H8.42771C8.75542 4.54078 9.02084 4.28511 9.02084 3.96986C9.02084 3.65461 8.75542 3.39894 8.42771 3.39894H8.42717ZM11.0683 0.433319C11.3841 0.433319 11.6398 0.688986 11.6398 1.00424L11.6393 1.57515H12.1587C12.3102 1.57515 12.4555 1.63533 12.5626 1.74245C12.6697 1.84957 12.7299 1.99485 12.7299 2.14634C12.7299 2.29783 12.6697 2.44311 12.5626 2.55023C12.4555 2.65735 12.3102 2.71753 12.1587 2.71753L11.6393 2.71699V3.28844C11.6392 3.43985 11.5791 3.58504 11.472 3.69209C11.3649 3.79914 11.2197 3.85928 11.0683 3.85928C10.9169 3.85928 10.7717 3.79914 10.6647 3.69209C10.5576 3.58504 10.4974 3.43985 10.4974 3.28844V2.71699H9.8745C9.79952 2.717 9.72527 2.70224 9.656 2.67355C9.58672 2.64487 9.52377 2.60281 9.47075 2.5498C9.41772 2.49678 9.37566 2.43384 9.34697 2.36457C9.31827 2.2953 9.3035 2.22105 9.3035 2.14607C9.3035 2.07109 9.31827 1.99684 9.34697 1.92757C9.37566 1.8583 9.41772 1.79536 9.47075 1.74234C9.52377 1.68932 9.58672 1.64727 9.656 1.61859C9.72527 1.5899 9.79952 1.57514 9.8745 1.57515H10.4974V1.00424C10.4974 0.688986 10.7531 0.433319 11.0683 0.433319Z" fill="var(--var-deactive-color)"></path>
						</svg>
						<span class="ZEcfoKF3Q_zq5EqaOdUy">
							<i v-if="!formConter.invite_code">*</i>
						</span>
					</div>
				</antInput>
			</div>
			<div class="ant-form-explain" v-if="fonData.invite_code.value">{{fonData.invite_code.value}}</div>
		</div>
		<ul class="HwvTcjBqOBJV3S7RoZ7g" v-if="false">
			<li class="xuanzeactive">
				<svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"
					viewBox="0 0 43.998 44.002">
					<path id="联合_669" data-name="联合 669"
						d="M22141.994,23716v-1H22143v1Zm-42.992,0v-1h.994v1Zm42.992-43v-1H22143v1Zm-42.992,0v-1h.994v1Z"
						transform="translate(-22099.002 -23671.998)" opacity="0.04"></path>
					<path id="密码"
						d="M3381.12,1299.991v-1.8a7.158,7.158,0,0,0-6.7-7.2,7.039,7.039,0,0,0-7.411,6.992v2h-.283a1.726,1.726,0,0,0-1.732,1.719v11.562a1.726,1.726,0,0,0,1.732,1.719H3381.4a1.725,1.725,0,0,0,1.732-1.719V1301.71a1.725,1.725,0,0,0-1.732-1.719Zm-11.758-1.833a4.7,4.7,0,0,1,9.406,0v1.833h-9.406Zm6.212,12.278a.493.493,0,0,1-.126.388.508.508,0,0,1-.376.167h-2.015a.507.507,0,0,1-.376-.167.493.493,0,0,1-.125-.388l.318-2.837a1.971,1.971,0,0,1-.826-1.608,2.016,2.016,0,0,1,4.031,0,1.97,1.97,0,0,1-.824,1.608Z"
						transform="translate(-3351.994 -1280.989)"></path>
				</svg>
				<span>{{ $t("Login._Cadastrodesenha") }} </span>
			</li>
			<li>
				<svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"
					viewBox="0 0 44 44">
					<g id="矩形_3452" data-name="矩形 3452" stroke-width="1" opacity="0">
						<rect width="44" height="44"></rect>
						<rect x="0.5" y="0.5" width="43" height="43"></rect>
					</g>
					<path id="路径_15116" data-name="路径 15116"
						d="M5.38.46V-12.2L2.16-9.4v-3.08l3.22-2.8H8.24V.46Zm7.98,0V-2.12l5.88-6.84a3.59,3.59,0,0,0,.62-.92,2.472,2.472,0,0,0,.18-.98,2.058,2.058,0,0,0-.48-1.42,1.775,1.775,0,0,0-1.4-.54,2.468,2.468,0,0,0-.7.1,1.743,1.743,0,0,0-.62.33,1.624,1.624,0,0,0-.45.62,2.373,2.373,0,0,0-.17.95H13.36a4.791,4.791,0,0,1,.37-1.93,4.222,4.222,0,0,1,1.01-1.44,4.34,4.34,0,0,1,1.52-.9,5.679,5.679,0,0,1,1.9-.31,5.579,5.579,0,0,1,1.92.32,4.439,4.439,0,0,1,1.51.9,4.071,4.071,0,0,1,.99,1.43,4.853,4.853,0,0,1,.36,1.91,4.128,4.128,0,0,1-.12,1.04,4.261,4.261,0,0,1-.33.87,5.166,5.166,0,0,1-.53.82q-.32.41-.7.87l-4.4,5.12h6.08V.46ZM34.72-4.1a4.938,4.938,0,0,1-.4,2.06A4.235,4.235,0,0,1,33.24-.57,4.343,4.343,0,0,1,31.65.3a6.527,6.527,0,0,1-1.93.28A6.635,6.635,0,0,1,27.85.32,4.568,4.568,0,0,1,26.26-.5a4.036,4.036,0,0,1-1.12-1.44,5.032,5.032,0,0,1-.44-2.1h2.88a2.422,2.422,0,0,0,.19.9,1.875,1.875,0,0,0,.46.64,1.91,1.91,0,0,0,.68.39,2.545,2.545,0,0,0,.81.13,2.11,2.11,0,0,0,1.53-.57,2.162,2.162,0,0,0,.59-1.63,2.192,2.192,0,0,0-.57-1.59,2.162,2.162,0,0,0-1.63-.59h-.42V-8.84h.42a1.843,1.843,0,0,0,1.52-.57,2.173,2.173,0,0,0,.46-1.41,1.878,1.878,0,0,0-.58-1.49,1.969,1.969,0,0,0-1.34-.51,1.947,1.947,0,0,0-1.36.49,1.927,1.927,0,0,0-.58,1.41H24.88a4.6,4.6,0,0,1,.41-1.89,4.293,4.293,0,0,1,1.03-1.4,4.527,4.527,0,0,1,1.51-.88,5.531,5.531,0,0,1,1.87-.31,5.426,5.426,0,0,1,1.92.33,4.594,4.594,0,0,1,1.52.92,4.154,4.154,0,0,1,1,1.42,4.551,4.551,0,0,1,.36,1.83,3.557,3.557,0,0,1-.52,2.04,3.667,3.667,0,0,1-1.3,1.18,4.038,4.038,0,0,1,1.44,1.3A3.911,3.911,0,0,1,34.72-4.1Z"
						transform="translate(3.836 29.4)"></path>

				</svg>
				<span>
					{{ $t("Login._Registrodocódigodeverificação") }}
					
				</span>
			</li>
		</ul>
		<!-- HwvTcjBqOBJV3S7RoZ7g -->
		
		<div v-if="$store.state.config.show_country" style="margin-bottom: .2rem;">
			<ant-select :value="value1" className="_max-width" :options="option1" @change="onChange">
			</ant-select>
		</div>
		<div v-if="$store.state.config.show_country" class="inner-textbox">
			<span class="ke1kCzBARxq5HSxbDQ6h"><span class="TMZWYZcIv5YQXVdFMVrw inner-text"
					style="-webkit-line-clamp: 2;">{{ $t("Login._accAcrt") }}</span></span>
		</div>
		<div>
			<div class="van-checkbox__icon_" style="padding: .2rem .28rem;">
				<van-checkbox v-model="checked" shape="square" checked-color="var(--theme-secondary-color-success)"
					icon-size=".32rem">
					<span class="chen_texbt">
						<span v-if="$store.state.config.ui_version == '3.7'" style="color:#92c0ff;">{{$t("Login._Tenhomaisde2")}}</span>
						<span v-else>{{$t("Login._Tenhomaisde")}}</span>
						<span v-if="$store.state.config.ui_version != '3.7'"></span>
						<span class="data-user-agreement" data-user-agreement="true">《{{ $store.state.config.ui_version == '3.7' ? $t("Login._AcordodeUsuário2") : $t("Login._AcordodeUsuário") }}》</span>
					</span>
				</van-checkbox>
			</div>
			<div class="" style="position:relative">
				<div class="" style="display: flex;align-items: center;padding-bottom: .2rem;">
					<button type="button"
						style="border-radius: .14rem;"
						@click="registerUrl"
						class="GaL3XJonIwzK4ZeJyCyq">
						{{ $t("Login._Registro") }}
					</button>
				</div>
				
				<div v-if="$store.state.config.register_give" class="uh6csli2MHzFz87__Phx tool-tips r1QnBDk2QnzYN6t7hweu" style="position: absolute;--cu-top: -.05rem; --cu-right:-.12rem; --cu-left: unset;">
					<p class="tool-tips-box sNgyWmhVEZVrbSGKDBra" :style="{'color':$store.state.config.ui_version=='3.7' ? '#fff' : '#fff'}">{{$t('components._Registrar')}} + {{$store.state.config.register_give}}</p>
					<p class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></p>
				</div>
			</div>
		</div>
		<ul class="footerMensg" style="display: flex;align-items: center;color:var(--theme-primary-color);font-size: .22rem;line-height: .26rem;text-align: center;"
		:style="!$store.state.config.category_hide.includes('_Demo') ? '' : 'justify-content: center;'">
			<li :style="!$store.state.config.category_hide.includes('_Demo') ? 'width: 50%;' : ''" @click="openUrlLofin('notice')">	{{ $t("Login._Suporteaocliente") }}</li>
			<!-- notice -->
			<li v-if="!$store.state.config.category_hide.includes('_Demo')" style="width: 50%;" @click="openUrlLofin('subgame',{
				id:'',
				category:'demo'
			})">{{ $t("Login._JogarGrátis") }}</li>
		</ul>
		
		<ul
			class="footerMensg3_7"
			style="display: flex;align-items: center;justify-content:center;color:var(--theme-primary-color);font-size: .22rem;line-height: .26rem;text-align: center;">
			<li style="width: 33.3%;" @click="openUrlLofin('notice')">{{$t("Login._Suporteaocliente") }}</li>
		</ul>
		<div class="footerMensg3_7mens">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div class="footerMensg3_7Login">{{$t('components._Registrovinculativo')}}</div>
			</div>
			<img :src="GoogleLOgo" style="width: .7rem;height: .7rem;margin: 0 auto;display: block;margin-top: .2rem;" alt="" sizes="" srcset="" />
		</div>
	</div>

</template>

<script>
	import register from "./register.vue"
	import antInput from "./input.vue"
	import {pustRegister} from "@/apis/modules/login.js";
	import { Toast } from 'vant';
	export default {
		components:{
			antInput
		},
		props: {
			isRecord: {
				type: Boolean,
				default: true,
			}
		},
		data() {
			return {
				GoogleLOgo:require('./../../assets/4Ddian/aoffx-gl7s6.png'),
				checked: true,
				isFocus: false,
				formConter:{
					user_name:'',
					phone:'',
					password:'',
					password_confirm:'',
					cpf:'',
					invite_code:'',
					invite_id:0,
				},
				value: '',
				
				suportType: (this.$store.state.config.register_type == 'all' || this.$store.state.config.register_type == 'name') ? this.$t('components._apenasM_Registro') : this.$t('components._CelularRegistroMe'),
				fonData: {
					user_name:{
						placeholder:this.$t('components._PorfavorinsiraConta'),
						tis:this.$t('Login._ErroNo'),
						value:''
					},
					password:{
						placeholder:this.$t('components._mboloscaracteres6_16'),
						tis:this.$t('components._mboloscaracteres6_16'),
						value:'',
						type:'password'
					},
					password_confirm:{
						placeholder:this.$t('Login._caracteresMens'),
						tis:this.$t('security._Senhaincorreta'),
						value:'',
						type:'password'
					},
					phone:{
						placeholder:this.$t('Login._vazioestar'),
						tis:this.$t('Login._vazioestar'),
						value:'',
						type:'password'
					},
					cpf:{
						placeholder:this.$t('components._IntroduzadoCPF'),
						tis:this.$t('components._IntroduzadoCPF'),
						value:'',
					},
					invite_code:{
						placeholder:'Código de Convite',
						tis:'O código de convite não pode estar vazio',
						value:'',
					}
					// 
				},
				mimaQiangdu:-1,
				value1: 0,
				option1: [
					{text: 'BRL (Real brasileiro)', value: 0},
				],
				country:{name:'country',code:'+55',full:'Brazil（+55）'},
				text: '',
				captcha:()=>{},
				riqifanshi:false,
				iscaptcha_configId:false,
				rememberPasswordList: [],
				rememberPasswordC: [],
			}
		},
		created() {
			let _this=this;
			if(this.$store.state.config.captcha_config.id){
				this.$initGeetest4({
					captchaId:this.$store.state.config.captcha_config.id,
					product: 'bind',
					language:_this.$store.state.config.captcha_config.language
				}, function (captcha) {
					_this.captcha=captcha;
					captcha.onReady(function () {}).onSuccess(function () {
						var result = captcha.getValidate();
						result.captcha_id =_this.$store.state.config.captcha_config.id;
						_this.pustRegister()
					}).onError(function () {
				
					})
				});	
			}else{
				this.iscaptcha_configId=true;
			}
			if(this.$store.state.config.ui_version == '3.4'){
				let inviteCode = window.localStorage.getItem('inviteID') || window.document.documentElement.getAttribute('data-inviteId');
				if(inviteCode)this.formConter.invite_code = inviteCode;
			}
			if(this.$store.state.config.currency == 'R$'){
				this.country = {name:'Brazil',code:'+55',full:'Brazil（+55）'};
			}else if(this.$store.state.config.currency == '$'){
				this.country = {name:'America',code:'+1',full:'America（+1）'};
			}else if(this.$store.state.config.currency == '₹'){
				this.country = {name:'India',code:'+91',full:'India（+91）'};
			}
		},
		mounted() {
			// this.$refs.searchVal.toggle()
			let rememberPassword = window.localStorage.getItem('rememberPassword');
			if (rememberPassword) {
				let aem = JSON.parse(rememberPassword);
				const uniqueArray = Array.from(aem.reduce((map, item) => {
					map.set(item.account, item);
					return map;
				}, new Map()).values());
				//this.formConter={...aem[0]};
				this.rememberPasswordList = uniqueArray;
				this.rememberPasswordC = uniqueArray;
				window.localStorage.setItem('rememberPassword', JSON.stringify(uniqueArray))
			}
		},
		methods: {
			checkPasswordStrength(password) {
				let score = 0;
				if (password.length > 6) score++;
				if (password.length > 0) score++;
				if(password.length >= 6){
					if (password.match(/[A-Z]/)) score++; // 大写字母
					if (password.match(/[a-z]/)) score++; // 小写字母
					if (password.match(/[0-9]/)) score++; // 数字
					if (password.match(/[\W_]/)) score++; // 特殊字符
				}
				if (password.length >= 6) score++;
				if (password.length > 10) score++;
				switch (score) {
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					return 1; // 弱
					case 5:
					return 2; // 中等
					case 6:
						return 3; // 强
					case 7:
					default:
					return 4; // 非常强
				}
			},
			validatePassword(password) {
				if (password.length < 6) {
						return false; // 密码长度必须为6位
					}
					// 定义正则表达式来检查不同的字符类型
					const hasDigit = /\d/.test(password);
					const hasLower = /[a-z]/.test(password);
					const hasUpper = /[A-Z]/.test(password);
					const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password); // 定义一些常见的特殊字符
					// 计算不同类型的字符数（这里实际上只关心是否存在，所以是布尔值）
					let typeCount = 0;
					if (hasDigit) typeCount++;
					if (hasLower) typeCount++;
					if (hasUpper) typeCount++;
					if (hasSpecial) typeCount++;
					// 检查是否至少有两种字符类型
					return typeCount >= (this.$store.state.config.ui_version == '3.4' ? 1 : 2);
			},
			pixelsRegister(){
				let ad_pixels = this.$store.state.config.ad_pixels
				// 加载facebook pixel
				if(ad_pixels.fb.length > 0){
					fbq('track', 'CompleteRegistration');
				}

				// 加载kwai pixel
				if(ad_pixels.kwai.length > 0){
					ad_pixels.kwai.forEach((v, i) => {
						kwaiq.instance(Number(v)).track('completeRegistration')
					});
				}
			},
			openUrlLofin(name,quser){
				this.openUrl(name,quser);
				this.$store.commit('isRecord')
			},
			pustRegister(){
				let inviteId = null;
				let inviteLink = window.document.documentElement.getAttribute('data-initLink');
				let strictId = window.document.documentElement.getAttribute('data-inviteId');
				if (this.$store.state.config.strict_invite || (this.$store.state.config.strict_sale && Number(strictId) < 100000000 && Number(strictId) > 60000000)) {
					inviteId = strictId;
				}
				inviteId = window.localStorage.getItem('inviteID') || inviteId;
				if(this.$store.state.config.ui_version == '3.4'){ inviteId = this.formConter.invite_code; }
				pustRegister({
					...this.formConter,
					invite_id:inviteId,
					invite_link:window.localStorage.getItem('initLink') || inviteLink,
					invite_code:window.localStorage.getItem('inviteID') || strictId,
				}).then(({data,msg,code})=>{
					if(code==0){
						// this.isLOding
						this.$emit('onLogin',{
							password:this.formConter.password,
							account:this.formConter.user_name || this.formConter.phone,
							isZhuzhe:true
						},this.rememberPasswordC)
						window.localStorage.setItem('CancelDisplay',this.$store.state.config.register_pop)
						// pixel 完成注册
						this.pixelsRegister();
					}else{
						// Toast(msg);
						Toast.fail({
							message:this.myLineBreaks(msg),
							duration:1000
						});
					}
					
				})
			},
			registerUrl(form){
				
				if(!this.checked){
					Toast.loading({
						message:this.myLineBreaks(this.$t('components._Verifiqueacordo')),
						duration:1000
					});
					return false;
				}

				let {user_name,password,phone,password_confirm,cpf,invite_code}=this.formConter;
				let _istrue=false;
				if(this.$store.state.config.register_type ==='all'){
					if(!user_name || user_name.length<4){
					_istrue=true;
				}
				}
				if(this.$store.state.config.register_type !=='name'){
					if(!phone || phone.length<=9){
						_istrue=true;
					}
				}
				if(!password || password.length<6){//  || password != password_confirm
					_istrue=true;
				}
				if(this.fonData.password.type=='text'){
					this.formConter.password_confirm=this.formConter.password
				}
				if(password != password_confirm){
					_istrue=true;
				}
				if(!_istrue && this.$store.state.config.ui_version == '3.4'){
					if(!invite_code || (invite_code.length!=8 && invite_code.length!=9)){
						_istrue=true;
					}
				}
				if(!_istrue && this.$store.state.config.register_cpf){
					_istrue = cpf.length != 14;
					if(!_istrue && !this.validarCPF(cpf)){
						Toast.fail({
							message:this.myLineBreaks(this.$t('components._vinculadoCPF')),
							duration:1000
						});
						return false;
					}
				}
				
				if(_istrue){
					for(let i in this.formConter){
						this.onInput(this.formConter[i],i)
					}
					return false;
				}
				if(!this.iscaptcha_configId){
					this.captcha.showCaptcha();
				}else{
					this.pustRegister();
				}
			},
			showHide(e){
				this.fonData[e].type=this.fonData[e].type=='password'?'text':'password'
			},
			myFormatNum(num,oldNum){
				let oldLength = oldNum ? oldNum.length : num.length;
				if(num.length==3 && oldLength > num.length){
					num = num.slice(0,2);
				}
				if(num.length==7 && oldLength > num.length){
					num = num.slice(0,6);
				}
				if(num.length==11 && oldLength > num.length){
					num = num.slice(0,10);
				}
				num = num.replace(/[^0-9]/g, '');
				if(num.length>=3 && num[3] != '.'){
					num = num.slice(0,3)+'.'+num.slice(3);
				}
				if(num.length>=7 && num[7] != '.'){
					num = num.slice(0,7)+'.'+num.slice(7);
				}
				if(num.length>=11 && num[11] != '-'){
					num = num.slice(0,11)+'-'+num.slice(11);
				}
				return num;
			},
			validarCPF(cpf) {
				cpf = cpf.replace(/[^\d]+/g,'');
				if(cpf == '') return false;
				// Elimina CPFs invalidos conhecidos
				if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
					cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" ||
					cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999"){
						return false;
					}
						
				// Valida 1o digito
				let add = 0;
				for (let i=0; i < 9; i ++){
					add += parseInt(cpf.charAt(i)) * (10 - i);
				}
				let rev = 11 - (add % 11);
				if (rev == 10 || rev == 11){
					rev = 0;
				}
				if (rev != parseInt(cpf.charAt(9))){
					return false;
				}
				// Valida 2o digito
				add = 0;
				for (let i = 0; i < 10; i ++){
					add += parseInt(cpf.charAt(i)) * (11 - i);
				}
				rev = 11 - (add % 11);
				if (rev == 10 || rev == 11){
					rev = 0;
				}
				if (rev != parseInt(cpf.charAt(10))){
					return false;
				}
				return true;
			},
			onFocus(e,formKey){
			  // if(!formKey){return false}
			  // let  formSo= this.formConter[formKey];
			  // let formValue= this.fonData[formKey];
			  // console.log(formValue,formKey)
			  // if(!formSo){
				 // formValue.value=formValue.placeholder 
			  // }
			},
			// @blur="onBlur"
			onBlur(e,formKey){
				if(!formKey){return false}
				let  formSo= this.formConter[formKey];
				let formValue= this.fonData[formKey];
				if(!formSo){
					formValue.value=formValue.placeholder 
				}
			},
			onInput(e,formKey){
				if(!formKey || formKey == 'invite_id'){return false}
				let last = formKey=='cpf' ? this.formConter[formKey] : '';
				this.formConter[formKey]=e;
				let formSo = this.formConter[formKey];
				let formValue= this.fonData[formKey];
				
				if(formSo){
					let regex = /^[a-zA-Z0-9_]{4,16}$/;
					if(formKey=='user_name' && !regex.test(e)){
						formValue.value=formValue.tis;
					}else if(formKey=='user_name' && regex.test(e)){
						if(/^\d+$/.test(e) && e.length>=6  && e.length<=12){
							formValue.value=this.$t('components._digitenovamente')
							return false;
						}
						formValue.value='';
					}
					if(formKey=='password'){
						this.mimaQiangdu=formSo.length?this.checkPasswordStrength(e):-1;
						if(!this.validatePassword(e)){
							formValue.value=formValue.tis;
						}else{
							formValue.value='';
						}
					}
					if(formKey=='password_confirm' && formSo){
						if(formSo!=this.formConter.password){
							formValue.value=formValue.tis;
						}else if(formSo==this.formConter.password){
							formValue.value='';
						}
					}
					
					if(formKey=='phone'&& formSo){
						if(e.length<=9){
							this.guoqu=true;
							formValue.value =this.$t('components._suporta_dr_55');
						}else if(e.length>11){
							this.guoqu=true;
							formValue.value = this.$t('components._suporta_dr_55');
						}else{
							formValue.value = '';
						}
					}
					if(formKey=='cpf' && formSo){
						let temp = this.myFormatNum(formSo,last)
						if(temp.length!=14){
							formValue.value =this.$t('components._IntroduzadoCPF');
						}else{
							formValue.value = '';
						}
						this.formConter.cpf = "\n";
						this.formConter.cpf = temp;
					}
					if(formKey=='invite_code' && formSo){
						if(e.length!=8 && e.length!=9){
							this.guoqu=true;
							formValue.value = 'O código de convite não pode estar vazio';
						}else{
							formValue.value = '';
						}
					}
					
				}else{
					formValue.value=formValue.placeholder 
				}
				this.formConter={
					...this.formConter
				}
				
			},
			onChange() {
			
			},
			isFun(e) {
				this.isFocus = e;
			},
		}
	}
</script>
<style>
		
	.login-register-from-space .van-checkbox__icon_{
		position: relative;
		padding-left: .24rem;
	}
	.login-register-from-space .van-checkbox__icon_ .van-checkbox__icon{
		position: absolute;
		left: 0;
		top: .2rem !important;
	}
	.login-register-from-space .van-search {
		display: flex;
		align-items: center;
		border-radius: .14rem;
		font-size: .22rem;
		height: .7rem;
		background-color: var(--theme-main-bg-color);
		border: 1px solid #d9d9d9;
		padding-right: .1rem;
		border-color: var(--theme-color-line);
	}

	.login-register-from-space .van-checkbox__icon .van-icon {
		border-radius: .06rem;
		border-color: var(--theme-color-line);
	}
	.login-register-from-space .van-ellipsis{
		position: relative;
		padding-left: .5rem;
		display: flex;
		align-items: center;
		height: .5rem;
	}
	.login-register-from-space .van-cell__title{
		position: relative;
		padding-left: 0.42rem;
	}
	.login-register-from-space .van-dropdown-menu__title{
		padding: 0 !important;
	}
	.login-register-from-space .van-cell__title:before,.login-register-from-space .van-ellipsis:before{
			content: '';
			display: inline-block;
		    position: relative;
		    width: 0.36rem;
		    height: 0.36rem;
			position: absolute;
			left:0;
			overflow: hidden;
			background-image: url('./../../assets/5e8fdeaf-a95f-4566-adac-d84c9605a176.png');
			background-position: -8.58857rem -3.35571rem;
			background-size: 9.33429rem 9.10929rem;
	}
	.login-register-from-space .van-cell__title:before{
		left: 0;
		top: -.05rem !important;
	}
	
	.login-register-from-space .van-search__content {
		background-color: var(--theme-main-bg-color);
	}

	.login-register-from-space .van-checkbox__label {
		display: flex;
		align-items: center;
		line-height: 1.5;
	}

	.login-register-from-space .data-user-agreement {
		color: var(--theme-primary-color)
	}
	.login-register-from-space input {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	}

	.login-register-from-space input::-webkit-input-placeholder {
		/* 使用webkit内核的浏览器 */
		color: var(--theme-text-color-placeholder) !important;
		line-height: .3rem !important;
		font-size: .22rem !important;
		font-weight: 400 !important;
	}

	.login-register-from-space input:-moz-placeholder {
		/* Firefox版本4-18 */
		color: var(--theme-text-color-placeholder) !important;
		line-height: .3rem !important;
		font-size: .22rem !important;
		font-weight: 400 !important;
	}

	.login-register-from-space input::-moz-placeholder {
		/* Firefox版本19+ */
		color: var(--theme-text-color-placeholder) !important;
		line-height: .3rem !important;
		font-size: .22rem !important;
		font-weight: 400 !important;
	}

	.login-register-from-space input:-ms-input-placeholder {
		/* IE浏览器 */
		color: var(--theme-text-color-placeholder) !important;
		line-height: .3rem !important;
		font-size: .22rem !important;
		font-weight: 400 !important;
	}
	
	.van-field__body input {
		color: var(--theme-text-color-darken);
	}

	.input-active {
		/* var(--theme-primary-color); */
		box-shadow: 0 2px 0 rgba(0, 0, 0, .045);
		border: .02rem solid var(--theme-filter-active-color) !important;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width {
		width: auto !important;
		max-width: initial !important;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-menu__bar {
		height: .7rem;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-menu__bar .van-dropdown-menu__item {
		border: .01rem solid var(--theme-color-line);
		background-color: var(--theme-main-bg-color);
		font-size: .2rem;
		height: .7rem !important;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		border-radius: .1rem;
		line-height: .5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 11px;
		padding-right: .4rem !important;
		color: var(--theme-text-color-lighten) !important;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .addcinte {
		height: .7rem;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-menu__bar .van-ellipsis {
		color: var(--theme-text-color-darken);
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-popup,
	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-item {
		width: 100%;
	}

	.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-item {
		top: .8rem !important;
	}
	.login-register-body .van-search__content{
		padding-left: 0px !important;
		margin-left: -.05rem;
	}
	/* border: .01rem solid var(--theme-primary-color) !important; */
</style>
<style scoped>
	.icontest{
		height: .7rem;
		/* width: 1.2rem; */
		/* padding-right: .15rem; */
		position: relative;
	}
	.icontest:before {
	    background-color: var(--theme-color-line);
	    bottom: .1rem;
	    content: "";
	    height: auto;
	    position: absolute;
	    right: 0.15rem;
	    top: .1rem;
	    width: .01rem;
	}
	.Conter_arrConte .icontest:before{
		display: none; 
	}
	.X5eogfqvbxD_ckZVQSll {
		color: var(--theme-text-color-darken);
		font-size: .22rem;
		line-height: 1.28;
		padding: 0 .3rem .1rem 0;
		text-align: left
	}

	.login-register-from-space {
		padding-left: .3rem;
		padding-right: .3rem;
		box-sizing: border-box;
		padding-top: .2rem;
		width: 100%
	}

	.ZEcfoKF3Q_zq5EqaOdUy {
		color: var(--theme-secondary-color-error);
		display: flex;
		align-items: center;
		margin-left: .02rem;
		position: relative;
		padding-right: .09rem;
	}
	.ZEcfoKF3Q_zq5EqaOdUy i{
		position: absolute;
		/* top: -.01rem; */
	}
	
	.GaL3XJonIwzK4ZeJyCyq {
	    background-color: #fff;
	    background-image: none;
	    border: 1px solid #d9d9d9;
	    border-radius: 4px;
	    -webkit-box-shadow: 0 2px 0 rgba(0,0,0,.015);
	    box-shadow: 0 2px 0 rgba(0,0,0,.015);
	    color: rgba(0,0,0,.65);
	    cursor: pointer;
	    display: inline-block;
	    font-size: 14px;
	    font-weight: 400;
	    height: 32px;
	    line-height: 1.499;
	    padding: 0 15px;
	    position: relative;
	    text-align: center;
	    -ms-touch-action: manipulation;
	    touch-action: manipulation;
	    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
	    transition: all .3s cubic-bezier(.645,.045,.355,1);
	    -webkit-user-select: none;
	    -moz-user-select: none;
	    -ms-user-select: none;
	    user-select: none;
	    white-space: nowrap
	}
	.GaL3XJonIwzK4ZeJyCyq{
		    background-color: var(--theme-primary-color);
		    border-color: var(--theme-primary-color);
			    font-size: .24rem;
			    height: .7rem;
				width: 100%;
				color: var(--theme-primary-font-color);
				    text-shadow: none;
					    box-shadow: 0 2px 0 rgba(0, 0, 0, .045);
	}
	
	.chen_texbt {
		color: var(--theme-text-color-darken);
		font-size: .22rem;
	}

	.ant-form-explain {
		color: var(--theme-secondary-color-error);
		font-size: .18rem;
		transition: color .3s cubic-bezier(.215, .61, .355, 1);
		line-height: 1.5 !important;
		position: relative;
		padding-left: .3rem;
		margin-bottom: .2rem;
	}

	.ant-form-explain::before {
		background-color: var(--theme-secondary-color-error);
		content: "";
		height: 0.18rem;
		margin-right: 0.1rem;
		visibility: visible;
		left: 0;
		top: 50%;
		margin-top: -0.09rem;
		width: 0.18rem;
		display: inline-block;
		position: absolute;
		background-image: url('./../../assets/5e8fdeaf-a95f-4566-adac-d84c9605a176.png');
		background-size: 13.068rem 12.753rem;
		border-radius: 50%;
		background-position: -12.888rem -3.825rem;
	}

	.HwvTcjBqOBJV3S7RoZ7g {
		display: flex;
		align-items: center;
		min-height: .26rem;
		font-size: .22rem;
		margin-bottom: .2rem;
	}

	.HwvTcjBqOBJV3S7RoZ7g li {
		display: flex;
		width: 50%;
		color: var(--theme-text-color-darken);
	}

	.HwvTcjBqOBJV3S7RoZ7g svg {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		background-color: var(--theme-main-bg-color);
		border: .01rem solid var(--theme-color-line);
		border-radius: 9999.99rem;
		color: var(--theme-text-color-lighten);
		display: -ms-flexbox;
		display: flex;
		font-size: .3rem;
		min-width: .3rem;
		justify-content: center;
		line-height: 1;
		margin-right: .1rem;
	}

	.xuanzeactive {
		color: var(--theme-primary-color) !important;
	}

	.xuanzeactive svg {
		color: #000 !important;
		border: .01rem solid var(--theme-primary-color);
		background-color: var(--theme-primary-color);
	}

	.right-icon {
		height: .36rem !important;
		width: .36rem !important;
	}

	.rBX8yUXrZ3DzhJ4ZvZUD {
		display: flex;
		align-items: center;
		margin-bottom: .2rem;
	}

	.ptEr7ybENfgNXBPMnsRb .rBX8yUXrZ3DzhJ4ZvZUD span {
		color: var(--theme-text-color-darken);
		font-size: .22rem;
		margin-right: .1rem;
		-webkit-transition: all .3s;
		transition: all .3s;
	}

	.ptEr7ybENfgNXBPMnsRb .rBX8yUXrZ3DzhJ4ZvZUD .VYe1C86O9HyF7KaCqIUg {
		background-color: var(--theme-color-line);
		border-radius: .12rem;
		height: .12rem;
		margin-right: .1rem;
		transition: all .3s;
		width: .8rem;
	}

	.ptEr7ybENfgNXBPMnsRb .rBX8yUXrZ3DzhJ4ZvZUD .QZ0QekXF9duW7ClyMSdQ {
		background-color: var(--theme-secondary-color-error) !important;
	}

	.inner-textbox {
		text-align: left !important;
		line-height: 1.5;
		margin-bottom: .2rem;
		font-size: 0.2rem;
		color: var(--theme-secondary-color-finance);
	}

	/* .ant-select-selection__placeholder {
	    height: .3rem;
	    line-height: .3rem;
		font-size: .22rem;
		    font-weight: 400;
	    margin-top: -.15rem;
		    color: var(--theme-text-color-placeholder);
	} */
	.uh6csli2MHzFz87__Phx {
	    height: .32rem;
	    left: var(--cu-left);
	    position: relative;
	    right: var(--cu-right);
	    top: var(--cu-top);
	    width: -webkit-fit-content;
	    width: -moz-fit-content;
	    width: fit-content;
	    z-index: 100
	}
	.r1QnBDk2QnzYN6t7hweu {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}
	.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
	    background-color: var(--theme-secondary-color-error);
	    border-radius: .1rem .1rem .1rem 0;
	    color: var(--theme-primary-color);
	    font-size: .16rem;
	    height: .22rem;
	    line-height: .22rem;
	    padding: 0 .05rem;
	}
	.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
	    border-bottom: .07rem solid transparent;
	    border-left: .07rem solid var(--theme-secondary-color-error);
	    border-right: .07rem solid transparent;
	    height: 0;
	    width: 0
	}
	
</style>
